// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1QSHK","range":"MonthRangeSwitch_range__2I0BO","disabled":"MonthRangeSwitch_disabled__1iv0g"};